import React, { useState, useRef, useEffect } from "react";
import {  useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Form from "react-validation/build/form";
import { useForm } from "react-hook-form";
import CheckButton from "react-validation/build/button";
import DatePicker from "react-datepicker";
import axios from 'axios';

import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import Helper from "../../../Helper";
import AddAssetRetrunService from "../../../services/contract/asset/assetreturnService";
import { getTrans as t } from "../../../Localization/translations";

function Assetsretrunscrren() {

const navigate = useNavigate()
const location = useLocation();
const asset_id = location.state
const [successful, setSuccessful] = useState(false);
const checkBtn = useRef();
const {  handleSubmit } = useForm();
const form = useRef();
const [loading, setLoading] = useState(true)
const [itemsAsset, setItemsAsset] = useState([]);
const [rowsData, setRowsData] = useState([]);

const handelDefault1 = () => {
  let url = API + "contracts/asset-view/" + asset_id + "/";
  axios.get(url, { headers: authHeader() })
    .then(response => setItemsAsset(response.data.data))
}

useEffect(() => {
  handelDefault1();
}, [])

const handleRegister = () => {
  setSuccessful(false);
  form.current.validateAll();
  if (checkBtn.current.context._errors.length === 0) {
    AddAssetRetrunService.AssetReturn(
      asset_id,
      itemsAsset.map((key) =>
      (
        key.id
      )),
      itemsAsset.map((key) => (Helper.DatePicker(rowsData[key.id]))),
    ).then(
      (response) => {
        if (response.data.success) {
          setSuccessful(true);
          setLoading(false)
          setTimeout(() => {
            navigate("/contract")
          }, 1000)
          toast.success(`${response.data.response}`,{
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",})
        }
        else {
          toast.error(`${response.data.error}`,{
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",})
          setSuccessful(false);
        }
      }
    )
  }
}

const handleChange = (id, e) => {
  const rowsInput = [...rowsData];
  rowsInput[id] = e
  setRowsData(rowsInput);
}

return (
<>
  <div className='container-fluid'>
  <ToastContainer />
    <div className="header pb-0 mb-2" >
      <div className="d-lg-flex">
        <div>
          <h5 className="mb-0 pt-3 tc">{t('Asset Return Screen')}</h5>
        </div>
      </div>
    </div>
    <div className="card">
      <div className="card-body">
        <Form role="form text-left"
          onSubmit={handleSubmit(handleRegister)}
          ref={form}
          action="."
          method="POST"
          id="addPartyContactForm" >
          {(
            <>
              <div className="row">
              </div>
              <div className="form-group row">
              </div>
              <table className="table table-striped align-items-center mb-0">
                <thead>
                  <tr>
                    <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">{t('Asset NUMBER')}</th>
                    <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">{t('Return Date')}</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    itemsAsset.map((key, index) => (
                      <tr>
                        <td>
                          <div className="d-flex px-2 py-1">
                            <div className="d-flex flex-column justify-content-center">
                              <span className="text-xs font-weight-bold">
                                {key.asset_number}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex px-2 py-1">
                            <div className="d-flex flex-column justify-content-center">
                              {
                                <div>
                                  <DatePicker
                                    key={key.id}
                                    className="form-control datepick"
                                    selected={(rowsData[key.id])}
                                    onChange={(e) => (handleChange(key.id, e))}
                                    placeholderText={"mm/dd/yyyy"}
                                    showYearDropdown // year show and scrolldown alos
                                    scrollableYearDropdown
                                    showMonthDropdown
                                    dropdownMode="select"
                                  />
                                </div>
                              }
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              <button type="submit" className="mt-4 btn-assets border-0 btn btn-primary btn-gradient-primary btn-md">{t("Submit")}</button>
            </>
          )}
          <CheckButton style={{ display: "none" }} ref={checkBtn} />
        </Form>
      </div>
    </div>
  </div>
</>
)
}

export default Assetsretrunscrren
